import {takeLatestF, putAll} from '@fl/cmsch-fe-library';
import {uniqBy} from 'lodash/fp';
import {SagaIterator} from 'redux-saga';
import {call, put, select} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {simpleAnimalBrowserSelector} from 'app/animal-browser/model/selector';
import {cabFilterFormName} from 'app/animal-browser/types/cab-filter-form-values';
import {genOrganizationOptions} from 'app/animal-browser/utils/gen-options';
import {t} from 'app/translations';
import {formHelpers} from 'utils/forms';
import {showBeError} from 'utils/show-be-error';

import {animalBrowserAction, GetOrganizationPtOptionsAction} from '../action';

const tt = t('animalBrowser');

function* execute({payload}: GetOrganizationPtOptionsAction): SagaIterator {
    const selectedValues = (yield* select(formHelpers.formValues(cabFilterFormName)))
        .prop('organizationPtIds').orElse([]);
    const oldOptions = (yield* select(simpleAnimalBrowserSelector.organizationPtOptions)).orElse([]);
    const selectedOptions = oldOptions.filter(option => selectedValues.includes(option.value));

    yield* put(animalBrowserAction.setLoading('organizationPtSearch', true));

    const response = yield* call(
        Api.getCabOrganizationsWithProficiencyTestMaintenanceAutocompleteList,
        {text: payload},
    );
    if (response.isSuccess) {
        yield* put(animalBrowserAction.getOrganizationsPtSuccess(
            uniqBy('value', [...selectedOptions, ...genOrganizationOptions(response.data)]),
        ));
    } else {
        yield putAll(showBeError(response, tt('filter')));
    }

    yield* put(animalBrowserAction.setLoading('organizationPtSearch', false));
}

/**
 * Loads point-of-service organization options for the comprehensive filters.
 *
 * @returns The saga watcher for `GET_ORGANIZATIONS_PT_OPTIONS`.
 */
export function* getOrganizationPtOptionsSaga(): SagaIterator {
    yield takeLatestF('animalBrowser/GET_ORGANIZATIONS_PT_OPTIONS', execute);
}
